import React from 'react';

import { connect, ConnectedProps } from 'react-redux';
import { TFunction } from 'react-i18next';
import {
  view,
  errorBoundary,
  withInject,
} from '@piwikpro/platform';
import { RouterService } from '@piwikpro/router-crate';
import {
  ModalView,
  Stack,
  Form,
  TextFieldControl,
  withTranslation,
} from '@piwikpro/ui-components';
import { FormValidator } from '@piwikpro/form-crate';
import { MetaSites } from '@piwikpro/meta-sites-crate';

const mapStateToProps = state => ({
  listFilters: state.metaSites.list.filters,
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  validation: FormValidator
  metaSites: MetaSites
  routerService: RouterService
  Title: any
}

interface Props extends ReduxProps, InjectedProps {
  t: TFunction
}

class CreateMetaSite extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleCancel() {
    const { routerService } = this.props;

    routerService.dismissAdministrationOverlay();
  }

  async handleSubmit(values, {
    setErrors,
    setSubmitting,
  }) {
    const {
      metaSites,
      routerService,
      listFilters,
    } = this.props;

    try {
      const response = await metaSites.createMetaSite(values);

      routerService.push({
        to: '/administration/meta-sites/$metaSiteId',
        params: { metaSiteId: response.data.id },
      });
      await metaSites.fetchMetaSites(listFilters);
    } catch (err: any) {
      setErrors(err.errors);
      setSubmitting(false);
    }
  }

  render() {
    const { validation, t, Title } = this.props;

    return (
      <Title part={t('meta-sites.create.title')} subset>
        <Form
          id="meta-site-create-form"
          initialValues={{
            name: '',
          }}
          validationSchema={validation.createValidationSchema(validators => ({
            name: validators.metaSites.name,
          }))}
          onSubmit={this.handleSubmit}
        >
          <ModalView
            title={t('meta-sites.create.title')}
            actions={(
              <Stack spacing="narrow" horizontalAlignment="right" verticalAlignment="center">
                <Form.Cancel onClick={this.handleCancel} />
                <Form.Submit />
              </Stack>
            )}
          >
            <TextFieldControl
              label={t('meta-sites.create.field.name')}
              name="name"
              autoFocus
              required
            />
          </ModalView>
        </Form>
      </Title>
    );
  }
}

export default connector(withInject<InjectedProps>({
  config: 'config',
  validation: 'FormCrate.validation',
  metaSites: 'MetaSitesCrate.metaSites',
  routerService: 'RouterCrate.router',
  Title: 'TitleCrate.components.Title',
})(
  view({ role: 'OWNER' }, false)(withTranslation(['administration', 'platform'])(
    errorBoundary(CreateMetaSite),
  )),
));
